const slideData = JSON.parse(document.getElementById("slideData").textContent);
let currentSlide = 0;
const totalSlides = slideData.length;
const track = document.getElementById("carouselTrack");
const indicators = document.querySelectorAll(".indicator");

function generateSlides() {
  track.innerHTML = "";
  slideData.forEach((slide) => {
    const slideEl = document.createElement("div");
    slideEl.className = "carousel-slide";
    slideEl.innerHTML = `
      <div class="ingredient-image" style="background-image: url('${slide.image}')"></div>
      <div class="ingredient-name">${slide.name}</div>
      <div class="ingredient-description">${slide.description}</div>
    `;
    track.appendChild(slideEl);
  });
}

function updateCarousel() {
  const translateX = -currentSlide * 100;
  track.style.transform = `translateX(${translateX}%)`;

  indicators.forEach((indicator, index) => {
    indicator.classList.toggle("active", index === currentSlide);
  });
}

function nextSlide() {
  currentSlide = (currentSlide + 1) % totalSlides;
  updateCarousel();
}

function previousSlide() {
  currentSlide = (currentSlide - 1 + totalSlides) % totalSlides;
  updateCarousel();
}

function goToSlide(index) {
  currentSlide = index;
  updateCarousel();
}

let startX = 0;
let endX = 0;

track.addEventListener("touchstart", (e) => {
  startX = e.touches[0].clientX;
});

track.addEventListener("touchend", (e) => {
  endX = e.changedTouches[0].clientX;
  const diff = startX - endX;
  if (Math.abs(diff) > 50) {
    diff > 0 ? nextSlide() : previousSlide();
  }
});

document.addEventListener("DOMContentLoaded", function () {
  generateSlides();
  updateCarousel();
});

setInterval(nextSlide, 5000);